// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"761c6fb8","239":"533ead8e","282":"1fc00be9","453":"36331516"}[chunkId] + ".chunk.js";
};